import * as React from 'react'

import { useLocation, Outlet } from 'react-router-dom';
import Paper from '@mui/material/Paper'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import './Layout.scss'
import { UcThemeContext } from '../lib/UcThemeProvider'
import { ApiClient } from '../lib/ApiClient'
import { useAuthenticated } from './auth/useAuthenticated'
import { domain } from '../domain';
import { UcAppBar } from './UcAppBar';

const apiClient = new ApiClient()

export const Layout = (props) => {
  const location = useLocation();
  // Todo: We can revisit this when we have a better idea on layout
  const renderSpecialContainer = location.pathname.includes('account/manage/2fa/setup');
  const userAuth = useAuthenticated(apiClient);

  // eslint-disable-next-line no-unused-vars
  const [themeState, themeDispatch] = React.useContext(UcThemeContext);

  return (
      <div className="layout" key="layout">
        {userAuth.isAuthenticated && (
            <UcAppBar />
        )}
        <Container component="div" maxWidth={renderSpecialContainer ? "sm" : "xs"} sx={{ mt: 4 }}>
          <Paper sx={{p: 2}} variant="outlined">
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                marginTop: 0,
                marginBottom: 0,
              }}
            >
                <img
                  src={`${domain.baseUrlEnerConnect}/themes/${themeState.logo}`}
                  alt="logo"
                  className="signIn-img__logo"
                  data-cy-id="logo"
                  style={{ paddingTop: '8px', paddingBottom: '8px', paddingLeft: '60px', paddingRight: '60px', height: 'auto', maxHeight: '200px', maxWidth: '100%', marginBottom: 15 }}
                />
            </div>
            {props.isAuthenticating && (
              <Box sx={{ mt: 5, textAlign: 'center' }}>
                <CircularProgress
                  color="primary"
                  size={70}
                  aria-label="Loading..."
                  title="Loading..."
                />
              </Box>
            )}
              {!props.isAuthenticating && <Outlet />}
            </Paper>
        </Container>
      </div>
  )
}
